const mapOtcErrorMessages = (error: string) => {
  switch (error) {
    case 'INVALID_CODE':
      return "That code doesn't match. Check your email, or resend below.";
    case 'EXPIRED_CODE':
      return 'That code has expired. Resend below to get a new one.';
    default:
      return 'Something went wrong. Please try again.';
  }
};

export default mapOtcErrorMessages;